import React from 'react'
import { Link } from 'react-router-dom'
import logo from '../../images/Horizontal-Logo-color.png'



const ClickHandler = () => {
    window.scrollTo(10, 0);
}


const Footer = (props) => {

    return (
        <footer className={"" + props.hclass}>
            <div className="wpo-upper-footer">
                <div className="container">
                    <div className="row">
                        <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                            <div className="widget about-widget">
                                <div className="logo widget-title">
                                    <img src={logo} alt="blog" />
                                </div>
                                <p>Transforming independent pharmacies through strategic investments and operational excellence. We acquire, optimize, and grow community pharmacies,</p>
                                <div className="social-widget">
                                    <ul>
                                        <li><Link onClick={ClickHandler} to="#"><i className="flaticon-facebook-app-symbol"></i></Link></li>
                                        <li><Link onClick={ClickHandler} to="#"><i className="flaticon-twitter"></i></Link></li>
                                        <li><Link onClick={ClickHandler} to="#"><i className="flaticon-linkedin"></i></Link></li>
                                        <li><Link onClick={ClickHandler} to="#"><i className="flaticon-instagram"></i></Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                            <div className="widget link-widget">
                                <div className="widget-title">
                                    <h3>Quick Links</h3>
                                </div>
                                <ul>
                                    <li><Link onClick={ClickHandler} to="#">Invest Now</Link></li>
                                    <li><Link onClick={ClickHandler} to="#">What We do</Link></li>
                                    <li><Link onClick={ClickHandler} to="#">Our Mission</Link></li>
                                    <li><Link onClick={ClickHandler} to="#">Contact Us</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                            <div className="widget link-widget s2">
                                <div className="widget-title">
                                    <h3>Useful Links</h3>
                                </div>
                                <ul>
                                    <li><Link onClick={ClickHandler} to="#">How It Works</Link></li>
                                    <li><Link onClick={ClickHandler} to="#">Investment Process</Link></li>
                                    <li><Link onClick={ClickHandler} to="#">For Pharmacies</Link></li>
                                    <li><Link onClick={ClickHandler} to="#">For Investors</Link></li>
                                </ul>
                            </div>
                        </div>

                        <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                            <div className="widget contact-widget">
                                <div className="widget-title">
                                    <h3>Contact Us</h3>
                                </div>
                                <ul>
                                    <li><i className="flaticon-email"></i><span>info@pharmacyfreedomfund.com</span>
                                    </li>
                                    <li> <i className="flaticon-telephone"></i><span>(908) 616-2889
                                    </span></li>
                                    <li><i className="flaticon-location-1"></i><span>555 NJ-18
                                        East brunswick <br />
                                        NJ 08816</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="wpo-lower-footer">
                <div className="container">
                    <div className="row g-0">
                        <div className="col col-lg-6 col-12">
                            <p className="copyright"> Copyright &copy; 2025 <Link onClick={ClickHandler} to="/">Pharmacy Freedom Fund</Link>.
                                All
                                Rights Reserved.</p>
                        </div>
                        <div className="col col-lg-6 col-12">
                            <ul>
                                <li><Link onClick={ClickHandler} to="#">Privace & Policy</Link></li>
                                <li><Link onClick={ClickHandler} to="/about-us">About us</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;







